import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

// Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
export const Route = createFileRoute("/_site/how-we-work")({
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "How We Work",
      description: "Our engagement process from first call to delivered package: diagnostic, plan, build, review, handoff.",
      path: "/how-we-work",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"How we work"} intro={"[SUPPLY: process step descriptions]"} />;
}
